import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketing-info',
  templateUrl: './marketing-info.component.html',
  styleUrls: ['./marketing-info.component.scss']
})
export class MarketingInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/marketing-info/marketing-info.component.ts